import i18n from "i18next";

export const getShortNameFromId = (event: number, idOnly = false) => {
  const prefix = idOnly ? "" : i18n.t("events.shortName", "RD");
  return `${prefix}${event}`;
};

// Handles temporary change in round numbering between R12-R24
export const getDisplayRoundNumber = (eventId: number) => {
  if (eventId < 12 || eventId > 24) return eventId;
  return eventId === 24 ? 12 : eventId + 1;
};
